/* eslint-disable */
class Yt {

  constructor(container,videotype){

    this.container = container;
    this.videotype = videotype;

    const bgMedia = this.container.querySelector('.background__media');

  
    this.videoID = bgMedia.dataset.videoid;
    this.video = this.container.querySelector('.video');
    this.player = null;

    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
    this.handleEvents = this.handleEvents.bind(this);
    this.init = this.init.bind(this);

    this.init();
    this.handleEvents();

  }


  init() {

    // crea lo script javascript che carica le youtube iframe api
    const ytTagSrc = 'https://www.youtube.com/iframe_api';

    if( $(`script[src="${ytTagSrc}"]`).length === 0 ) {

      const tag = document.createElement('script');
      tag.src = ytTagSrc;

      const head = document.getElementsByTagName('head')[0];
      head.appendChild(tag);

    }


    window.onYouTubeIframeAPIReady = () => {

      if(typeof this.videoID === "undefined" || this.videoID === ''){
        return;
      }

      this.player = new YT.Player(this.video.getAttribute('id'), {
        height: '390',
        width: '640',
        videoId: this.videoID,
        playerVars: {
          'autoplay': 0,
          'controls': 0,
          'disablekb': 1,
          'fs': 0,
          'loop': 1,
          'playsinline': 1,
          'rel': 0,
          'showinfo': 0,
          'modestbranding': 1,
          'iv_load_policy': 3,
          'enablejsapi': 1,
          'origin':window.location.origin
        },
        events: {
          'onReady': (event) => {
            // this.player.mute();
            // this.play();
          },
          'onStateChange': (event) => {

            if(event.data === 0){
              this.container.dispatchEvent(new CustomEvent('docarouselnext', {
                bubbles: true,
              }));
            }
            /*this.player.mute();
            this.player.play();*/
          }
        }
      });

    };

  }


  handleEvents() {

  }

  play() {
    this.player.playVideo();
    this.player.unMute();
  }

  stop() {
    this.player.stopVideo();
  }

}

export default Yt;



// WEBPACK FOOTER //
// ./scripts/classes/videoplayer/yt.js